export const config = {
  webEnv: import.meta.env.VITE_APP_WEB_ENV,
  webUrl: import.meta.env.VITE_APP_WEB_URL ?? '',
  apiBase: import.meta.env.VITE_APP_WEB_API ?? '',
  firebaseApiKey: import.meta.env.VITE_APP_FIREBASE_API_KEY ?? '',
  firebaseAuthDomain: import.meta.env.VITE_APP_FIREBASE_AUTH_DOMAIN ?? '',
  firebaseTenantId: import.meta.env.VITE_APP_FIREBASE_TENANT_ID ?? ''
} as const;

export const isProd = config.webEnv === 'production';
export const isDev = config.webEnv === 'develop';

export const isWeChatEnvironment = () => {
  const ua = navigator.userAgent.toLowerCase();
  return ua.includes('miniprogram');
};

export const isWebEnvironment = () => {
  return !isWeChatEnvironment();
};

export const isWeb = isWebEnvironment();
export const isWechat = isWeChatEnvironment();
